import { AccentDialog } from "./AccentDialog";
import { AccentButton } from "../controls/AccentButton"; // or wherever AccentButton lives

export const ResendChatMessageDlg = (props) => {
    const onResend = () => props.onClose({ action: "resend" });
    const channels = props.channels?.length ? props.channels : (props.channel ? [props.channel] : []);
    const altButtons = channels.map((c) => (
        <AccentButton key={`resend-${c}`} tagName={`resendAlternateBtn-${c}`} onClick={() => props.onClose({ action: "resend-alternate", channel: c })}>
            Resend via {c}
        </AccentButton>
    ));

    return (
        <AccentDialog
            headerContent="Resend message?"
            onClose={props.onClose}
            actionsContent={[
                <>
                    <AccentButton key="resend" tagName="resendBtn" onClick={onResend}>Resend</AccentButton>
                    {altButtons}
                </>
            ]}
        >
            <div>
                This message failed to send. Do you want to try again?
                {!!props.preview && (
                    <div style={{ marginTop: 8, fontSize: 12, opacity: 0.7 }}>
                        Preview: <br/>{props.preview}
                    </div>
                )}
            </div>
        </AccentDialog>
    );
};
